import { render, staticRenderFns } from "./tcyx.vue?vue&type=template&id=ec293c04&scoped=true&"
import script from "./tcyx.vue?vue&type=script&lang=js&"
export * from "./tcyx.vue?vue&type=script&lang=js&"
import style0 from "./tcyx.vue?vue&type=style&index=0&id=ec293c04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec293c04",
  null
  
)

export default component.exports